import { render, staticRenderFns } from "./BestCoachPage.vue?vue&type=template&id=dd521c44&"
import script from "./BestCoachPage.vue?vue&type=script&lang=js&"
export * from "./BestCoachPage.vue?vue&type=script&lang=js&"
import style0 from "./BestCoachPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports